


































































































































































































































































































import {
  Component,
  Mixins,
  Watch,
  Prop,
} from 'vue-property-decorator';
import {
  Getter,
  Mutation,
  State,
  Action,
} from 'vuex-class';
import DateField from '@/components/FormBuilder/fields/DateField.vue';
import ObjectField from '@/components/FormBuilder/fields/ObjectField.vue';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import ApplicationHROptions from '@/graphql/ApplicationHROptions.gql';
import WorkCollection from '@/components/ApplicationHR/WorkCollection.vue';
import ApplicationHRTemplate from '@/components/ApplicationHR/ApplicationHRTemplate.vue';
import BooleanField from '@/components/FormBuilder/fields/BooleanField.vue';
import TimeField from '@/components/FormBuilder/fields/TimeField.vue';
import RepeatableInputGroup from '@/components/common/RepeatableInputGroup.vue';

import SelectOptionsFetcher from '@/mixins/SelectOptionsFetcher';
import { differenceBetweenTime } from '@/utils/time';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import NormalizerMixin from '@/mixins/NormalizerMixin';
import UserMixin from '@/mixins/UserMixin';

import { Roles } from '@/store/profile/types';
import { CrudOperation } from '@/types/CrudOperation';
import axios from 'axios';
import { graphqlEndpoints } from '@/utils/config';
import FieldCollectionNormalizer from '@/classes/normalizers/field-normalizers/FieldCollectionNormalizer';
import _, { cloneDeep, isNull, Many } from 'lodash';

import { required, helpers } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';

import {
  like,
  and,
  or,
} from '@/classes/pimcore-filtering/Filters';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';

import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';
import { PlatformType } from '@/store/directory/types';
import { TemplateType } from '@/store/templates/types';

const timeFormatted = helpers.regex('timeFormatted', /^([01]\d|2[0-3]):?([0-5]\d)$/);

const suppliersWithVModel = {
  applicationId: null,
  supplier: null,
  quantity: null,
  size: null,
};

const formDataWorkModel = {
  suppliers_with_v: [suppliersWithVModel],
  time_from: '',
  time_to: '',
  units: null,
  work_type: null,
};

const formDataWork = [formDataWorkModel];

const workValidations = {
  $each: {
    suppliers_with_v: {
      $each: {
        supplier: {
          required,
        },
        quantity: {
          required,
        },
        size: {
          required,
        },
      },
    },
    work_type: {
      required,
    },
    units: {
      required,
    },
    time_from: {
      required,
      timeFormatted,
    },
    time_to: {
      required,
      timeFormatted,
    },
  },
};

interface ValidationsObject {
  passed: boolean;
  validations: Record<string, any>;
}

@Component({
  components: {
    DateField,
    ObjectField,
    WorkCollection,
    BooleanField,
    TimeField,
    RepeatableInputGroup,
    CustomSelect,
    ApplicationHRTemplate,
  },
})
export default class CreationForm extends Mixins(SelectOptionsFetcher, EntityHelperMixin, UserMixin, validationMixin, NormalizerMixin) {
  @State('isModalVisible', { namespace: 'entity' })
  readonly isModalVisible!: boolean;

  @Action('toggleEntityModal', { namespace: 'entity' })
  toggleEntityModal: any;

  @Prop({
    type: Object,
    default: null,
  }) readonly prefilledFormData!: any

  suppliersWithVModel = suppliersWithVModel;

  formDataWorkModel = formDataWorkModel;

  formData: Record<string, any> = {
    client: {},
    coordinator: {},
    date_from: '',
    date_to: '',
    platform: {},
    night_work: _.cloneDeep(formDataWork),
    day_work: _.cloneDeep(formDataWork),
    night_comment: '',
    day_comment: '',
  };

  defaultFormData: Record<string, any> = {
    client: null,
    coordinator: null,
    date_from: '',
    date_to: '',
    platform: {},
    night_work: _.cloneDeep(formDataWork),
    day_work: _.cloneDeep(formDataWork),
    night_comment: '',
    day_comment: '',
  };

  deletedWorks = {
    day_work: null,
  };

  isApplyingTemplate = false;

  @Validations()
  validations = {
    formData: {
      night_work: workValidations,
      day_work: workValidations,
      coordinator: {
        required,
      },
      client: {
        required,
      },
      platform: {
        required,
      },
      date_from: {
        required,
      },
      date_to: {
        required,
      },
    },
  }

  dayWorkIsDisabled = false;

  loading = true;

  toPreviewModal = false;

  objectFieldNormalizer = new ObjectFieldNormalizer();

  fieldCollectionNormalizer = new FieldCollectionNormalizer();

  @State('platforms', { namespace: 'directory' })
  readonly platformsList!: PlatformType[];

  coordinatorsList: Array<any> = [];

  workTypesList: Array<any> = [];

  clientsList: Array<any> = [];

  selectOptions: Record<string, any[]> = {
    supplier: [],
    units: [],
  };

  booleanFields = [
    {
      label: 'Тяжелый товар',
      fieldName: 'category',
    },
    {
      label: 'Техника',
      fieldName: 'technology',
    },
    {
      label: 'ПК',
      fieldName: 'PC',
    },
  ]

  workCollections = [
    {
      name: 'night',
      formDataParam: 'night_work',
      title: 'Ночь',
      disabled: false,
      returnWorkDisabled: false,
      icon: 'mdi-weather-night',
      defaultTime: {
        from: '20:00',
        to: '08:00',
      },
    },
    {
      name: 'day',
      formDataParam: 'day_work',
      title: 'День',
      disabled: false,
      returnWorkDisabled: false,
      icon: 'mdi-white-balance-sunny',
      defaultTime: {
        from: '08:00',
        to: '20:00',
      },
    },
  ]

  workCollectionsValidations = [
    {
      name: 'size',
      func: (collectionData: any) => {
        if (!collectionData || !collectionData.suppliers_with_v || !collectionData.suppliers_with_v.length) {
          return true;
        }
        const overallSize = collectionData.size;

        let overallCalculatedSize = '';
        if (collectionData.suppliers_with_v.length > 1) {
          overallCalculatedSize = collectionData.suppliers_with_v.reduce(
            (acc: any, curr: any) => (parseInt(acc.size, 10) || acc) + parseInt(curr.size, 10),
          );
        } else {
          overallCalculatedSize = collectionData.suppliers_with_v[0].size;
        }

        if (parseInt(overallSize, 10) !== parseInt(overallCalculatedSize, 10)) {
          return {
            type: 'error',
            text: 'Сумма объема по поставщикам не совпадает с общим объемом',
          };
        }
        return true;
      },
    },
    {
      name: 'time_warnings',
      func: (collectionData: any) => {
        const time_from = collectionData.time_from;
        const time_to = collectionData.time_to;
        const difference = differenceBetweenTime(time_from, time_to);
        if (difference < 6 * 60) {
          return {
            type: 'warning',
            text: 'График менее 6 часов, но оплата будет как за 6 часов',
          };
        }
        return true;
      },
    },
  ];

  workCollectionValidity: ValidationsObject = {
    passed: true,
    validations: {},
  };

  coordinatorRole: any = null;

  get supplierList() {
    return this.selectOptions.supplier.filter((i) => i?.PlantsHR?.some((p: any) => Number(p.id) === Number(this.formData.platform?.id)));
  }

  get platforms() {
    return this.userPlatforms;
  }

  get workTypeSelectAllowed() {
    return !!(this.formData?.platform?.id && this.formData?.client?.id && this.formData?.coordinator?.id);
  }

  @Getter('getSession', { namespace: 'profile' })
  session!: Record<string, any>;

  @Mutation('setOperation', { namespace: 'entity' })
  setOperation!: (operation: CrudOperation) => void;

  @Watch('isModalVisible')
  onModalStateChange() {
    for (let i = 0; i < this.workCollections.length; i += 1) {
      this.workCollections[i].disabled = false;
    }
  }

  onDateToChange(dateTo: string) {
    const dateFromFormat = this.formData.date_from ? new Date(this.formData.date_from) : new Date(dateTo);
    const dateToFormat = new Date(dateTo);
    if (this.datesDiff(dateFromFormat, dateToFormat) > 1 || dateToFormat < dateFromFormat) {
      dateToFormat.setDate(dateToFormat.getDate() - 1);
      this.formData.date_from = dateToFormat;
    }
    this.updateLocalStorage();
  }

  onDateFromChange(dateFrom: string) {
    const dateToFormat = this.formData.date_to ? new Date(this.formData.date_to) : new Date(dateFrom);
    const dateFromFormat = new Date(dateFrom);
    if (this.datesDiff(dateToFormat, dateFromFormat) > 1 || dateFromFormat > dateToFormat) {
      dateFromFormat.setDate(dateFromFormat.getDate() + 1);
      this.formData.date_to = dateFromFormat;
    }
    this.updateLocalStorage();
  }

  datesDiff(date1: Date, date2: Date) {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  async beforeMount() {
    if (this.prefilledFormData) {
      this.formData = this.prefilledFormData;
    } else {
      const newApplication = localStorage.getItem('formData')
        ? JSON.parse(String(localStorage.getItem('formData'))).newApplication
        : null;
      if (newApplication) {
        this.formData = newApplication;
        if (!this.formData.night_work) {
          this.onDeleteWork('night');
        }
        if (!this.formData.day_work) {
          this.onDeleteWork('day');
        }
      }
    }
    this.selectOptions = await this.getClientOptions(ApplicationHROptions);
    this.loading = false;
    if (this.isHR) {
      if (_.isEmpty(this.formData.platform)) {
        this.coordinatorsList = await this.loadCoordinators(await this.getCoordinatorRole(), null);
      } else {
        this.coordinatorsList = await this.loadCoordinators(await this.getCoordinatorRole(), this.formData.platform);
      }

      if (!this.formData?.coordinator?.id) {
        await this.changeCoordinator(null);
      } else
      if (!this.coordinatorsList.find((v: any) => v.id.toString() === this.formData.coordinator.id.toString())) {
        await this.changeCoordinator(null);
      }
    }
    if (this.isCoordinator) {
      this.coordinatorsList = [this.pimcoreUser];
      this.formData.coordinator = this.pimcoreUser;
      await this.changeCoordinator(this.pimcoreUser);
    }
    await this.tryLoadWorkTypes();
    if (this.isCoordinator && this.userPlatformIds.length === 0) {
      this.$bus.$emit('notification', 'У вас отсутствует платформа', 'error');
    }
  }

  async getCoordinatorRole() {
    if (isNull(this.coordinatorRole)) {
      this.coordinatorRole = (await this.loadRoles()).find((v: any) => v.role_type === Roles.COORDINATOR);
    }
    return this.coordinatorRole;
  }

  async loadRoles() {
    return this.loadEntityListing('Role', {}, 'network-only', { maxDepth: 3 });
  }

  async loadCoordinators(role: any, platform: any) {
    if (!this.pimcoreUser || !this.pimcoreUser.id) {
      console.error('Current user doesn\'t exist in pimcore');
      return [];
    }
    const filterBuilder = new FilterBuilder();

    if (isNull(platform)) {
      const ors: any[] = this.userPlatformIds.map(
        (item: number) => like('PlantsHR', `%${item}%`),
      );
      filterBuilder.addFilters(and(or(...ors), and(like('role__id', role.id))));
    } else {
      filterBuilder.addFilters(and(like('PlantsHR', `%${platform.id}%`), and(like('role__id', role.id))));
    }

    return this.loadEntityListing(
      'User',
      {
        filter: filterBuilder.build(),
      },
      'network-only',
      {
        maxDepth: 2,
        byObject: {
          ...this.getNormalizerRequiredFields('User'),
          PlantsHR: {
            ...this.getNormalizerRequiredFields('PlantsHR'),
          },
        },
      },
    );
  }

  async loadWorkTypes(platform: string, client: string) {
    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(
      and(
        and(
          like('platform__id', platform),
        ),
        and(
          like('client__id', client),
        ),
      ),
    );
    return this.loadEntityListing('Work', {
      filter: filterBuilder.build(),
    }, 'network-only', { maxDepth: 3 });
  }

  async loadClients(platform: string) {
    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(
      and(
        like('Plants', `%${platform}%`),
      ),
    );
    return this.loadEntityListing('Client', {
      filter: filterBuilder.build(),
    }, 'network-only', { maxDepth: 3 });
  }

  getValidationErrors(validations: any): Array<string> {
    const errors: Array<string> = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    if (validations.timeFormatted === false) {
      errors.push('Неверный формат времени (23:59)');
    }
    return errors;
  }

  async useTemplate({ template }: TemplateType) {
    this.isApplyingTemplate = true;
    await this.clearData();
    Object.keys(this.defaultFormData).forEach((key) => {
      if (template[key]) {
        this.$set(this.formData, key, template[key]);
      }
    });
    await this.tryLoadWorkTypes();
    this.$nextTick(() => {
      this.isApplyingTemplate = false;
    });
  }

  handleOnInputValidations(value: any, onInput: any, validations: any) {
    if (validations && validations.$touch) {
      validations.$touch();
    }
    if (onInput && typeof onInput === 'function') {
      onInput(value);
    }
  }

  validateFormData(showNotification = false): ValidationsObject {
    const validations: Record<string, any> = {};
    let passed = true;
    let worksCount = 0;
    for (let i = 0; i < this.workCollections.length; i += 1) {
      const workSpec = this.workCollections[i];
      const operationsArray = this.formData?.[workSpec.formDataParam];
      if (!operationsArray || !operationsArray.length) {
        continue;
      }
      for (let j = 0; j < operationsArray.length; j += 1) {
        const operation = operationsArray[j];
        if (operation.work_type === null || operation.work_type === undefined) {
          continue;
        }
        worksCount += 1;
        const allErrorsPath = `${workSpec.formDataParam}_${j}`;
        for (let k = 0; k < this.workCollectionsValidations.length; k += 1) {
          const validation = this.workCollectionsValidations[k];
          const validityResp = validation.func(operation);
          const currErrorPath = `${workSpec.formDataParam}_${j}_${validation.name}`;
          if (validityResp !== true) {
            if (validityResp.type === 'error') {
              passed = false;
            }
            if (!validations[allErrorsPath]) {
              validations[allErrorsPath] = [];
            }
            validations[allErrorsPath].push(validityResp);
            validations[currErrorPath] = validityResp;
          }
        }
      }
    }
    if (!worksCount) {
      passed = false;
      if (showNotification) {
        this.$bus.$emit('notification', 'Не выбрано ни одной операции', 'error');
      }
    }
    return {
      passed,
      validations,
    };
  }

  formDataChanged(data: any, path: Many<string | number | symbol>) {
    _.set(this.formData, path, data);
    this.workCollectionValidity = this.validateFormData(false);
    this.updateLocalStorage();
  }

  updateLocalStorage() {
    this.$emit('save-to-local-storage', {
      newApplication: this.formData,
    });
  }

  async changeCoordinator(coordinator: any) {
    if (!coordinator) {
      this.formData.coordinator = null;
      this.clientsList = [];
    } else if (coordinator?.PlantsHR?.length > 0 && _.isEmpty(this.formData.platform)) {
      this.formData.platform = coordinator.PlantsHR[0];
      this.clientsList = await this.loadClients(this.formData.platform.id);
    } else if (!_.isEmpty(this.formData.platform)) {
      this.clientsList = await this.loadClients(this.formData.platform.id);
    } else {
      this.$bus.$emit('notification', 'У данного координатора отсутствует платформа', 'error');
    }

    if (!this.isApplyingTemplate && coordinator?.id !== this.formData?.coordinator?.id) {
      if (this.formData.night_work) {
        this.formData.night_work.forEach((operation: any) => {
          operation.work_type = null;
        });
      }
      if (this.formData.day_work) {
        this.formData.day_work.forEach((operation: any) => {
          operation.work_type = null;
        });
      }
    }
  }

  async changePlatform(platform: any) {
    if (!platform) {
      this.clientsList = [];
    } else {
      this.clientsList = await this.loadClients(platform.id);
      if (this.isHR && platform.id !== this.formData?.coordinator?.PlantsHR[0]?.id) {
        this.coordinatorsList = await this.loadCoordinators(await this.getCoordinatorRole(), platform);
      }
    }

    if (!this.isApplyingTemplate && platform?.id !== this.formData?.platform?.id) {
      if (this.formData.night_work) {
        this.formData.night_work.forEach((operation: any) => {
          operation.work_type = null;
        });
      }
      if (this.formData.day_work) {
        this.formData.day_work.forEach((operation: any) => {
          operation.work_type = null;
        });
      }
    }
  }

  changeClient(client?: any) {
    if (!this.isApplyingTemplate && client?.id !== this.formData?.client?.id) {
      if (this.formData.night_work) {
        this.formData.night_work.forEach((operation: any) => {
          operation.work_type = null;
        });
      }
      if (this.formData.day_work) {
        this.formData.day_work.forEach((operation: any) => {
          operation.work_type = null;
        });
      }
    }
  }

  async tryLoadWorkTypes() {
    if (this.workTypeSelectAllowed) {
      this.workTypesList = await this.loadWorkTypes(this.formData.platform.id, this.formData.client.id);
    }
  }

  getAvailableWorkTypes() {
    return this.workTypesList;
  }

  getObjectFieldPropsByName(fieldName: string) {
    let items = this.selectOptions[fieldName];
    if (fieldName === 'workType') {
      items = this.filterWorkTypes();
    }
    return {
      items,
      normalizer: this.objectFieldNormalizer,
      'item-text': 'name',
      'item-value': 'id',
    };
  }

  onDeleteWork(workName: string) {
    const collection = this.workCollections.find((w) => w.name === workName);
    if (!collection) {
      return;
    }
    if (this.formData[collection.formDataParam]?.length) {
      this.formData[collection.formDataParam] = this.formData[collection.formDataParam].splice(0, this.formData[collection.formDataParam].length);
    }
    collection.disabled = true;
    delete this.formData[collection.formDataParam];
  }

  onReturnWork(workName: string) {
    const collection = this.workCollections.find((w) => w.name === workName);
    if (!collection) {
      return;
    }

    this.$set(this.formData, collection.formDataParam, _.cloneDeep(formDataWork));
    collection.disabled = false;
    this.$nextTick(() => {
      const fieldValidation = this.$v.formData[collection.formDataParam];
      if (fieldValidation) {
        fieldValidation.$reset();
      }
    });
  }

  async onSubmit() {
    this.loading = true;
    try {
      this.$v.$touch();
      this.workCollectionValidity = this.validateFormData(true);
      if (this.$v.$invalid || !this.workCollectionValidity.passed) {
        throw new Error('validation errors');
      }
    } catch (e) {
      this.loading = false;
      return;
    }
    if (this.workCollectionValidity.passed) {
      let response: any;
      const preparedFormData = this.prepareFormData(this.formData);
      try {
        response = await axios.post(graphqlEndpoints.createApplication, preparedFormData);
      } catch (error) {
        const errorMessage = (error as any).response?.data?.error
          || (error as any).response?.data?.message
          || (error as any).message
          || 'Не удалось создать заявку. Попробуйте позже.';

        this.$bus.$emit('notification', errorMessage, 'error');
        this.loading = false;
        return;
      }
      if (response && response.status >= 200 && response.status < 300) {
        this.toggleEntityModal(false);
        this.$emit('save-to-local-storage', { newApplication: null });
        this.$bus.$emit('entity-refetch');
      } else if (response) {
        const errorMessage = response.data?.error
          || response.data?.message
          || 'Не удалось создать заявку. Попробуйте позже.';
        this.$bus.$emit('notification', errorMessage, 'error');
      }
    }
    this.loading = false;
  }

  async clearData() {
    this.formData = JSON.parse(JSON.stringify(this.defaultFormData));
    this.workCollections.forEach((collection) => { collection.disabled = false; });
  }

  prepareFormData(formData: any): any {
    formData = cloneDeep(formData);
    formData.platform = this.objectFieldNormalizer.normalize(formData.platform);
    formData.coordinator = this.objectFieldNormalizer.normalize(formData.coordinator);
    formData.client = this.objectFieldNormalizer.normalize(formData.client);
    formData.night_work = formData.night_work ? this.prepareFormDataWork(formData.night_work) : null;
    formData.day_work = formData.day_work ? this.prepareFormDataWork(formData.day_work) : null;
    formData.night_work = {
      items: {
        GeneralWork: formData.night_work,
      },
    };
    formData.day_work = {
      items: {
        GeneralWork: formData.day_work,
      },
    };
    return formData;
  }

  prepareFormDataWork(workArray: Array<any>) {
    workArray = cloneDeep(workArray);
    for (let i = 0; i < workArray.length; i += 1) {
      const work = workArray[i];
      if (work.work_type !== null && work.work_type !== undefined) {
        work.work_type = this.objectFieldNormalizer.normalize(work.work_type);
      }
      if (work.units !== null && work.units !== undefined) {
        work.units = this.objectFieldNormalizer.normalize(work.units);
      }
      if (!work.suppliers_with_v) {
        continue;
      }
      for (let j = 0; j < work.suppliers_with_v.length; j += 1) {
        const supplier = work.suppliers_with_v[j];
        supplier.supplier = this.objectFieldNormalizer.normalize(supplier.supplier);
        work.suppliers_with_v[j] = supplier;
      }
      workArray[i] = work;
    }
    return workArray.filter((work) => work.work_type !== null && work.work_type !== undefined);
  }

  filterWorkTypes() {
    if (!this.formData.platform) {
      return [];
    }

    return this.selectOptions.workType.filter((item) => item.platform.id === this.formData.platform.id);
  }

  previewApplication() {
    this.setOperation(CrudOperation.preview);

    this.toPreviewModal = true;

    this.$bus.$emit('preview', {
      data: this.formData,
      options: this.selectOptions,
    });
  }
}
